export default __webpack_public_path__ + "static/media/icon_6.9ab80d25.png";